import VestingsPlans from './container';

export default VestingsPlans;
